import TextField, {TextFieldProps} from '@material-ui/core/TextField';
import React, {FunctionComponent, useCallback} from 'react';
import {FieldRenderProps} from 'react-final-form';
import {noop} from 'utils';

interface FFTextFieldProps extends FieldRenderProps<string, HTMLElement> {
  InnerInputProps?: TextFieldProps;
  required?: boolean;
  disabled?: boolean;
  allowResize?: boolean;
  showError?: boolean;
}

const FFTextField: FunctionComponent<FFTextFieldProps> = ({
  input,
  meta,
  required = false,
  disabled = false,
  allowResize = false,
  showError = true,
  InnerInputProps: {helperText, onChange = noop, multiline, inputProps, ...rest} = {},
}: FFTextFieldProps) => {
  const errorMessage = meta.error || meta.submitError;
  const doShowError = showError &&  !!(meta.touched && errorMessage);

  if (allowResize) {
    if (!inputProps) {
      inputProps = {
        style: {
          resize: 'vertical',
        },
      };
    } else {
      inputProps.style = {
        resize: 'vertical',
      };
    }
  }

  const handleChange = useCallback(
    event => {
      input.onChange(event);
      onChange(event);
    },
    [onChange, input]
  );

  return (
    <TextField
      required={required}
      disabled={disabled}
      {...input}
      onChange={handleChange}
      inputProps={inputProps}
      {...rest}
      error={doShowError}
      helperText={doShowError ? errorMessage : helperText}
      multiline={multiline}
      autoComplete="false"
    />
  );
};

export default FFTextField;
